import { Button } from '@mui/material';
import { Stack, SxProps } from '@mui/system';
import { buildDataTestIdAttribute } from '@src/utils';

const classes = {
  active: {
    textDecoration: 'underline',
    ':disabled': {
      color: '#19A1B7',
    },
  } as SxProps,
  inActive: {
    color: '#6B7280',
  } as SxProps,
};

type ToggleTextButtonProps = {
  firstTextButton: string;
  secondTextButton: string;
  activeButton: string;
  setActiveButton: React.Dispatch<React.SetStateAction<string>>;
  color?: 'secondary' | 'primary';
  variant?: 'contained' | 'outlined' | 'text';
  dataTestId?: string;
};

export const ToggleTextButton: React.FC<ToggleTextButtonProps> = ({
  firstTextButton,
  secondTextButton,
  activeButton,
  setActiveButton,
  dataTestId,
  color = 'secondary',
  variant = 'text',
}) => {
  const onClickButton = (value: string) => {
    setActiveButton(value);
  };

  return (
    <Stack gap="24px" direction="row" mt="24px" mb="12px">
      <Button
        variant={variant}
        color={color}
        onClick={() => onClickButton(firstTextButton)}
        sx={{
          ...(activeButton === firstTextButton ? classes.active : classes.inActive),
          padding: '0 0 0 24px',
          minHeight: '0px',
          height: '20px',
        }}
        disabled={activeButton === firstTextButton}
        {...buildDataTestIdAttribute(dataTestId, 'button-tab-diagnoses')}
      >
        {firstTextButton}
      </Button>
      <Button
        variant={variant}
        color={color}
        onClick={() => onClickButton(secondTextButton)}
        sx={{
          ...(activeButton === secondTextButton ? classes.active : classes.inActive),
          padding: '0',
          minHeight: '0px',
          height: '20px',
        }}
        disabled={activeButton === secondTextButton}
        {...buildDataTestIdAttribute(dataTestId, 'button-tab-diagnosis-group')}
      >
        {secondTextButton}
      </Button>
    </Stack>
  );
};
